import React from "react";
import CIcon from "@coreui/icons-react";
import { CNavGroup, CNavItem } from "@coreui/react";
import { cilSpeedometer, cilLayers, cibCreativeCommonsSamplingPlus, cilUserPlus, cilBaby, cilDollar, cilCalendar, cilCalculator } from "@coreui/icons";

const normalize = (str) => str?.toLowerCase().replace(/\s+/g, "");
const allowedModules = sessionStorage.getItem("routes") || "[]";
const isPermitted = (name) => {
  const role = sessionStorage.getItem("role");
  let parsedRoutes = [];

  if (typeof allowedModules === "string") {
    const cleaned = allowedModules
      .replace(/^"(.*)"$/, "$1")
      .replace(/\\"/g, '"');
    parsedRoutes = JSON.parse(cleaned);
  } else if (Array.isArray(allowedModules)) {
    parsedRoutes = allowedModules;
  } else {
    parsedRoutes = [];
  }

  if (role === "admin" || role === "company") return true;
  if (name === "Dashboard") return true;

  return parsedRoutes?.some((mod) => normalize(mod?.name) === normalize(name));
};
const filterMenuItems = (menu) => {
  const role = sessionStorage.getItem("role");

  return menu
    .map((item) => {
      const roles = item.showOnlyForRole;
      const roleMatch =
        role === "admin" ||
        !roles ||
        (Array.isArray(roles) ? roles?.includes(role) : roles === role);

      if (!roleMatch) return null;

      if (role === "admin" || role === "company") {
        return item;
      }

      if (item.items && Array.isArray(item.items)) {
        const filteredSubItems = item?.items?.filter((subItem) =>
          isPermitted(subItem.name)
        );

        if (filteredSubItems?.length > 0 || isPermitted(item.name)) {
          return { ...item, items: filteredSubItems };
        }

        return null;
      } else {
        return isPermitted(item.name) ? item : null;
      }
    })
    .filter(Boolean);
};

const Menu = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/dashboard",
    showOnlyForRole: [
      "admin",
      "company",
    ],
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Emi Calculator",
    to: "/emi-calculator",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Company",
    to: "/users",
    showOnlyForRole: [
      "admin",
    ],
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Directors",
    to: "/directors",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilBaby} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Dealers",
    to: "/dealers",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Products",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    to: "/productlist",
    icon: (
      <CIcon icon={cibCreativeCommonsSamplingPlus} customClassName="nav-icon" />
    ),
  },
  {
    component: CNavGroup,
    name: "Manage Staff",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilLayers} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Add Staff",
        to: "/staff/addstaff",
      },
      {
        component: CNavItem,
        name: "Staff Details",
        to: "/staff",
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Loans",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Apply Loan",
        to: "/customers",
      },
      {
        component: CNavItem,
        name: "Customer Registration",
        to: "/newregisterform",
      },
      {
        component: CNavItem,
        name: "Track Customer Details",
        to: "/customer-profile",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Customer EMI Record",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    to: "/emi-details",
    icon: <CIcon icon={cilDollar} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Emis Collections and Status",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    to: "/payment-collection",
    icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Payment Collection",
        to: "/payment-collection",
      },
      {
        component: CNavItem,
        name: "Pending Emi Details",
        to: "/pending-emi-details",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Loans Status",
    to: "/loan-status",
    showOnlyForRole: [
      "admin",
      "company",
    ],
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Accounting",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Master Account",
        to: "/masteraccount",
      },
      {
        component: CNavItem,
        name: "Payment",
        to: "/paymentForm",
      },
      {
        component: CNavItem,
        name: "Journals",
        to: "/journaldata",
      },
      {
        component: CNavItem,
        name: "Ledger",
        to: "/ledger",
      },
      {
        component: CNavItem,
        name: "BankStatement",
        showOnlyForRole: [
          "admin",
          "company",
        ],
        to: "/bankstatement",
        icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Profit And Loss Account",
        to: "/profitandlosslist",
      },
      {
        component: CNavItem,
        name: "Banking",
        showOnlyForRole: [
          "admin",
          "company",
        ],
        to: "/banking",
        icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Reports",
    showOnlyForRole: [
      "admin",
      "company",
      "employee",
      "staff",
      "manager",
      "agent",
    ],
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Branch Report",
        to: "/branchreport",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
      {
        component: CNavItem,
        name: "Directors Report",
        to: "/directorsreport",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
      {
        component: CNavItem,
        name: "Emis Report",
        to: "/emisreport",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
      {
        component: CNavItem,
        name: "Loans Report",
        to: "/loans-report",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
      {
        component: CNavItem,
        name: "Customer Report",
        to: "/customerreport",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
      {
        component: CNavItem,
        name: "Expenses Report",
        to: "/expensereport",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
      {
        component: CNavItem,
        name: "Product By Details",
        to: "/productbydetails",
        showOnlyForRole: [
          "admin",
          "company",
          "employee",
          "staff",
          "manager",
          "agent",
        ],
      },
    ],
  },
];

export default filterMenuItems(Menu);
